import _ from 'lodash';
import { parseGetParam } from './parse-get-param';
import Wix from './wix-sdk-polyfill';

export const getInstance = () => {
  return parseGetParam('instance');
};

export const isWixMobile = () => {
  const deviceType = parseGetParam('deviceType') || parseGetParam('devicetype');
  if (deviceType && deviceType !== '') {
    return String(deviceType).indexOf('mobile') >= 0;
  } else {
    return undefined;
  }
};

//this is a heavy regexp, avoid from calling it if not needed
//TODO: call this once, save it on the window or other global and use the global var instead
// prettier-ignore
export const isUserAgentMobile = () => {
  let result = false;
  try {
    (function (a) {
      /* eslint-disable no-useless-escape */
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
        /* eslint-enable no-useless-escape */
        result = true;
      }
    })(navigator.userAgent || navigator.vendor || window.opera);
  } catch (e) {
    //navigator not defined on test env
  }
  return result;
};

export const isMobile = () => {
  const wixMobile = isWixMobile();
  return _.isUndefined(wixMobile) ? isUserAgentMobile() : wixMobile;
};

export const isLandscape = () => {
  let isLandscape = false;
  if (!isMobile()) {
    isLandscape = false;
  }
  if (!_.isUndefined(window.orientation)) {
    isLandscape = window.orientation === 90 || window.orientation === -90;
  } else {
    const mql = window.matchMedia('(orientation: landscape)');
    if (mql && mql.matches === true) {
      isLandscape = true;
    } else {
      isLandscape = false;
    }
  }
  return isLandscape;
};

export const getScreenWidth = () => {
  if (isLandscape()) {
    return Math.max(window.screen.width, window.screen.height);
  } else {
    return window.screen.width;
  }
};

export const getWidth = () => parseGetParam('width');

export const isEditor = () => parseGetParam('viewMode') === 'editor';

export const isPreview = () => parseGetParam('viewMode') === 'preview';

export const isSeoViewMode = () => parseGetParam('viewMode') === 'viewer-seo';

export const isSite = () => {
  return !isEditor() && !isPreview();
};

//example for url in wix:
//http://localhost:4000/?
// cacheKiller=1476285364360
// &compId=TPASection_iu7270jb
// &deviceType=desktop
// &instance=nfD1PM20vEXqfHStvJjMGauBkBPw_dxEW4W8JPZm02Q.eyJpbnN0YW5jZUlkIjoiNWMzZWIwYjYtZWE2OS00OTQ0LWI0YjUtNTMwN2I5YjJkNTQ5Iiwic2lnbkRhdGUiOiIyMDE2LTEwLTEyVDE1OjE2OjEzLjcwMloiLCJ1aWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUiLCJwZXJtaXNzaW9ucyI6Ik9XTkVSIiwiaXBBbmRQb3J0IjoiNDYuMTE2Ljk2LjUvMzUxNDciLCJ2ZW5kb3JQcm9kdWN0SWQiOm51bGwsImRlbW9Nb2RlIjpmYWxzZSwic2l0ZU93bmVySWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUifQ
// &locale=en
// &section-url=http%3A%2F%2Flocalhost%3A4000%2F
// &target=_self
// &viewMode=editor
// &width

//example for the settings url:
//http://localhost:4000/app-settings.html
// ?compId=tpaSettings
// &endpointType=settings
// &instance=nfD1PM20vEXqfHStvJjMGauBkBPw_dxEW4W8JPZm02Q.eyJpbnN0YW5jZUlkIjoiNWMzZWIwYjYtZWE2OS00OTQ0LWI0YjUtNTMwN2I5YjJkNTQ5Iiwic2lnbkRhdGUiOiIyMDE2LTEwLTEyVDE1OjE2OjEzLjcwMloiLCJ1aWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUiLCJwZXJtaXNzaW9ucyI6Ik9XTkVSIiwiaXBBbmRQb3J0IjoiNDYuMTE2Ljk2LjUvMzUxNDciLCJ2ZW5kb3JQcm9kdWN0SWQiOm51bGwsImRlbW9Nb2RlIjpmYWxzZSwic2l0ZU93bmVySWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUifQ
// &locale=en
// &origCompId=TPASection_iu7270jb
// &viewMode=editor
// &width=404

//example for url of the widget
// https://forums.wix.com/widget?
// cacheKiller=1477743410718
// &compId=comp-iusrvptg
// &deviceType=desktop
// &instance=-9rk9pM4lPRwaF0OmD2QPFfH4OnpQ9TqDWzLqco8l3U.eyJpbnN0YW5jZUlkIjoiMTZiOGUzNTQtYzFmOS00OWZkLThiYjktY2RkYjIwZDE3MmVkIiwic2lnbkRhdGUiOiIyMDE2LTEwLTI5VDEyOjE2OjQ4Ljc1M1oiLCJ1aWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUiLCJwZXJtaXNzaW9ucyI6Ik9XTkVSIiwiaXBBbmRQb3J0IjoiODkuMTM5LjE4My44NC81NTE3MCIsInZlbmRvclByb2R1Y3RJZCI6bnVsbCwiZGVtb01vZGUiOmZhbHNlLCJhaWQiOiI4MWMxOGRkNC01MjRlLTRkNzgtOGRmYy05OWVkY2JjYjU0NWYiLCJiaVRva2VuIjoiZGRlMWVkZWUtNWI5OS0wN2FjLTI0YmMtNTg3MDFhNjNmZDNlIiwic2l0ZU93bmVySWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUifQ
// &locale=en
// &viewMode=site
// &width=100

export const getCompId = search => parseGetParam('origCompId', search) || parseGetParam('compId', search);

export const getViewMode = search => parseGetParam('viewMode', search);

export const getExternalId = search => parseGetParam('externalId', search);

export const getLocale = search => parseGetParam('locale', search) || 'en';

export const notifyAppAboutSettingsUpdate = message =>
  Wix.Settings.triggerSettingsUpdatedEvent(message, Wix.Utils.getOrigCompId());
